import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=f772a564&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=f772a564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f772a564",
  null
  
)

export default component.exports